import { Http, Request, RequestOptionsArgs, Response, RequestOptions, ConnectionBackend, Headers, XHRBackend} from '@angular/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationUser } from './services/ApplicationUser';
import { Observable } from 'rxjs/Rx';
import { ErrorHandler } from './services/ErrorHandler';

const ENV = process.env;
declare var jQuery:any;

@Injectable()
export class HttpInterceptor extends Http {
    private host: string = ENV.ADMIN_API_URL || '';

    constructor(backend: ConnectionBackend, defaultOptions: RequestOptions, private _router: Router) {
        super(backend, defaultOptions);
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return super.request(url, options);
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        url = `${this.host}${url}`;
        return this.intercept(super.get(url, this.getRequestOptionArgs(options)));
    }

    post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        url = `${this.host}${url}`;
        return this.intercept(super.post(url, body, this.getRequestOptionArgs(options)));
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        url = `${this.host}${url}`;
        return this.intercept(super.put(url, body, this.getRequestOptionArgs(options)));
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        url = `${this.host}${url}`;
        return this.intercept(super.delete(url, this.getRequestOptionArgs(options)));
    }

    getRequestOptionArgs(options?: RequestOptionsArgs) : RequestOptionsArgs {
        const user = ApplicationUser.getInstance();

        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }
        options.headers.append('Content-Type', 'application/json');

        if (user.originalUser && user.originalUser.id !== user.user.id) {
            options.headers.append('X-UserId', user.user.id.toString() );
            options.headers.append('Authorization', user.originalUser.access_token);
        }
        else {
            options.headers.append('Authorization', HttpInterceptor.accessToken);
        }

        return options;
    }

    intercept(observable: Observable<Response>): Observable<Response> {
        return observable.catch((err, source) => {
            if (err.status  == 401) {
                AuthErrorEventer.getIt().runAll();
                ApplicationUser.getInstance().logout();
                this._router.navigate(['/login']);
                return Observable.empty();
            } else {
                const e = ErrorHandler.getInstance();
                e.emit(err);
                return Observable.throw(err);
            }
        });
    }

    static get accessToken() {
        const user = ApplicationUser.getInstance();
        return user.getAccessToken();
    }
}

export function HttpProviderFactory(xhrBackend: XHRBackend, requestOptions:
    RequestOptions, router: Router) {
    return new HttpInterceptor(xhrBackend, requestOptions, router);
}

export function handleResponseError(err) {
    let errorData = JSON.parse(err._body);
    let errMessage = '';

    if ( errorData.validation && errorData.validation.length ) {
        errorData.validation.forEach((val) => {
            errMessage += `'${val.key}' ${val.message}`;
        });
    } else {
        errMessage = errorData.message;
    }

    return errMessage;
}


export function detectBody() {
    if (jQuery(document).width() < 769) {
        jQuery('body').addClass('body-small')
    } else {
        jQuery('body').removeClass('body-small')
    }
}

export function smoothlyMenu() {
    if (!jQuery('body').hasClass('mini-navbar') || jQuery('body').hasClass('body-small')) {
        // Hide menu in order to smoothly turn on when maximize menu
        jQuery('#side-menu').hide();
        // For smoothly turn on menu
        setTimeout(
            function () {
                jQuery('#side-menu').fadeIn(400);
            }, 200);
    } else if (jQuery('body').hasClass('fixed-sidebar')) {
        jQuery('#side-menu').hide();
        setTimeout(
            function () {
                jQuery('#side-menu').fadeIn(400);
            }, 100);
    } else {
        // Remove all inline style from jquery fadeIn function to reset menu state
        jQuery('#side-menu').removeAttr('style');
    }
}

@Injectable()
export class AuthErrorEventer {
    private static _it: AuthErrorEventer;

    private constructor () {
    }

    static getIt() {
        if (! AuthErrorEventer._it) AuthErrorEventer._it = new AuthErrorEventer();
        return AuthErrorEventer._it;
    }

    private _events: (() => any)[] = [];

    set event(f: () => any) {
        this._events.push(f);
    }

    runAll() {
        for (let f of this._events) {
            f();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app.helpers.ts